module.exports = __webpack_public_path__ + "img/fourday_ps_24.5233a117.jpg";